class WCTopBar extends WCDummy {
  #button;
  #cookieName = "movpri-topbar-noticed";

  constructor() {
    super({ tag: WCTopBar.tag });
    if (this.discardable) {
      this.#button = document.querySelector("button");
      this.#button.addEventListener("click", this.handleDiscard.bind(this));
    }
  }

  static get tag() {
    return "wc-topbar";
  }

  connectedCallback() {
    document.body.style.setProperty("--wc-topbar-height", "0px");
    if (this.discardable) {
      if (Cookies.get(this.#cookieName)) {
        this.remove();
      } else {
        document.body.style.setProperty(
          "--wc-topbar-height",
          this.offsetHeight + "px"
        );
      }
    }
  }

  disconnectedCallback() {}

  get discardable() {
    return this.hasAttribute("expires");
  }
  get ttl() {
    return this.getAttribute("expires");
  }

  handleDiscard() {
    Cookies.set(this.#cookieName, this.ttl);
    this.remove();
    document.body.style.setProperty("--wc-topbar-height", "0px");
  }
}
customElements.define(WCTopBar.tag, WCTopBar);
